module.exports = __webpack_public_path__ + "static/img/table_oof.484242f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/table_oof.png
// module id = sTd9
// module chunks = 171